"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_card-item.scss");

var _getOrganisationDisplayName = _interopRequireDefault(require("../../../utils/getOrganisationDisplayName"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function getSubPackageName(subPackage) {
  if (!subPackage) {
    return '-';
  }

  return subPackage.custom ? "".concat(subPackage.templatedFrom, " (Custom)") : subPackage.templatedFrom;
}

function getRemainingVideos(subPackage) {
  if (!subPackage) {
    return '-';
  }

  return "".concat(subPackage.videoQuantity, " Videos Left");
}

var CardItem = /*#__PURE__*/function (_Component) {
  _inherits(CardItem, _Component);

  function CardItem() {
    _classCallCheck(this, CardItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardItem).apply(this, arguments));
  }

  _createClass(CardItem, [{
    key: "getOverlayProps",
    value: function getOverlayProps() {
      var _this$props = this.props,
          organisation = _this$props.organisation,
          onClick = _this$props.onClick,
          hasUpdatePermission = _this$props.hasUpdatePermission,
          actionOptions = _this$props.actionOptions;
      var isDraftOrganisation = organisation.status === 'DRAFT';
      return {
        button: {
          action: onClick,
          name: isDraftOrganisation && hasUpdatePermission ? 'Resume Draft' : 'View Profile'
        },
        more: {
          options: actionOptions,
          color: 'white'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var organisation = this.props.organisation;
      var imageUrl = organisation.imageUrl,
          subPackage = organisation.package;
      return _react.default.createElement(_uiKit.List.CardItem, {
        overlayProps: this.getOverlayProps(),
        coverImageProps: {
          imageUrl: imageUrl
        }
      }, _react.default.createElement("div", {
        className: "card-item__info"
      }, _react.default.createElement(_uiKit.Text, {
        heading5: true,
        noMargin: true
      }, (0, _getOrganisationDisplayName.default)(organisation)), _react.default.createElement("div", {
        className: "card-item__info__package"
      }, _react.default.createElement(_uiKit.Text, null, getSubPackageName(subPackage)), _react.default.createElement(_uiKit.Text, null, _react.default.createElement("strong", null, getRemainingVideos(subPackage))))));
    }
  }]);

  return CardItem;
}(_react.Component);

exports.default = CardItem;